import React, { ReactNode } from 'react'
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
// import 'react-pdf/dist/esm/Page/TextLayer.css'
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack'

import {
  Box,
  Center,
  Flex,
  Image,
  Text,
  useDisclosure,
  // Link,
} from '@chakra-ui/react'

// import { PospImages } from 'Assets/Posp';
import { type DropzoneInputProps, type DropzoneRootProps } from 'react-dropzone'
import { AiOutlineClose } from 'react-icons/ai'
import FilePreview from '../FilePreview'
import { LockIcon } from '@chakra-ui/icons'

interface FileUploadProps {
  id?: number | null
  iconWidth?: string
  iconHeight?: string
  uploadDesc?: string
  subDescLink?: ReactNode
  getRootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T
  getInputProps: <T extends DropzoneInputProps>(props?: T | undefined) => T
  preview: File | null | undefined
  previewUrl?: any | undefined
  inputFieldImage?: string | any
  customStyleBoxWidth?: string
  previewStyleLeft?: string
  handleFileCancel?: any
  excludeIds?: number[]
}
const FileUpload = ({
  id,
  iconHeight,
  iconWidth,
  subDescLink,
  getRootProps,
  inputFieldImage,
  getInputProps,
  uploadDesc,
  preview,
  previewUrl,
  customStyleBoxWidth,
  previewStyleLeft,
  handleFileCancel,
  excludeIds,
}: FileUploadProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const getHandleFileCancelKey = () => {
    if (id === 1) {
      return 'noc'
    } else if (id === 2) {
      return 'panFront'
    } else if (id === 3) {
      return 'panBack'
    } else if (id === 4) {
      return 'addressProofFront'
    } else if (id === 5) {
      return 'addressProofBack'
    } else if (id === 6) {
      return 'education'
    } else if (id === 7) {
      return 'passport'
    } else if (id === 8) {
      return 'cheque'
    } else if (id === 9) {
      return 'gstDoc'
    }

    return 'nokey'
  }

  const cancelHandler = () => {
    // console.log('cancel handler called')
    const newKey = getHandleFileCancelKey()
    // console.log(newKey)
    handleFileCancel(newKey)
  }
  return preview ? (
    <Box>
      <Box position='relative' w={customStyleBoxWidth ?? '100%'}>
        <Box
          position='absolute'
          w={customStyleBoxWidth ?? '100%'}
          h='130px'
          // bg='black'
          background={'rgba(0, 0, 0, 0.4)'}
          // opacity='0.4'
          zIndex='30'
          rounded='lg'
          border={excludeIds && excludeIds.includes(id ?? -1) ? '2px solid red' : ''}
        ></Box>
        <Box position='absolute' top='40%' zIndex='30' left={previewStyleLeft ?? '30%'}>
          {preview.name || (excludeIds && excludeIds.includes(id ?? 0)) ? (
            <Box border='1px solid white' rounded='xl'>
              <Text
                cursor='pointer'
                onClick={onOpen}
                color='white'
                fontSize='sm'
                fontWeight='bold'
                px='8px'
                py='2px'
              >
                Preview
              </Text>
            </Box>
          ) : (
            <Box ml={6}>
              <LockIcon fontSize={'2xl'} color='#fff' />
            </Box>
          )}

          <FilePreview
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            preview={preview}
            previewUrl={previewUrl}
          />
        </Box>
        <Box right={4} top={2} position='absolute' zIndex={40}>
          {(preview.name || (excludeIds && excludeIds.includes(id ?? 0))) && (
            <AiOutlineClose cursor='pointer' onClick={cancelHandler} color='white' />
          )}
        </Box>
        {preview?.type === 'application/pdf' ? (
          <Box mt='20px'>
            <Box
              width={customStyleBoxWidth ?? '225px'}
              height='130px'
              overflow='hidden'
              style={{
                zIndex: '0',
                margin: '0px 0px 20px 0px',
                borderRadius: '10px',
              }}
            >
              <Document file={previewUrl}>
                <Page pageNumber={1} />
              </Document>
            </Box>
            {/* <iframe
              src={previewUrl}
              width={customStyleBoxWidth ?? '225px'}
              height="130px"
              frameBorder="0"
              style={{
                borderStyle: 'none',
                margin: '0px 0px 20px 0px',
                border: 'none',
                borderRadius: '10px',
              }}
            /> */}
          </Box>
        ) : (
          <Image
            w={customStyleBoxWidth ?? '225px'}
            h='130px'
            my='20px'
            rounded='lg'
            src={previewUrl}
          />
        )}
      </Box>
    </Box>
  ) : (
    <Box
      w={customStyleBoxWidth ?? '225px'}
      h='130px'
      my='20px'
      // py="10"
      border='1px dashed #A5A5A5'
      rounded='lg'
      {...getRootProps()}
    >
      <Center h='100%' w='100%'>
        <>
          <Flex
            flexDirection='column'
            alignItems='center'
            justifyContent='center'
            h='100%'
            w='100%'
          >
            <Center>
              <Image
                cursor='pointer'
                src={inputFieldImage}
                w={iconWidth ?? '60px'}
                h={iconHeight ?? '40px'}
                // mr={5}
              />
              <Text
                ml={5}
                cursor='pointer'
                textAlign='center'
                fontSize='md'
                maxW='110px'
                py='5px'
                color='#0F57B3'
              >
                {uploadDesc}
              </Text>
            </Center>

            {subDescLink && (
              <Text width='90%' align='center' color='#A5A5A5' pl={2} pt={2} style={{ fontSize: '12px' }}>
                {subDescLink}
              </Text>
            )}

            <input {...getInputProps()} />
          </Flex>
        </>
      </Center>
    </Box>
  )
}

export default FileUpload
